module.exports = __webpack_public_path__ + "media/images/hitfun/icon.reply.black-293aaae575aa48865163378b06d64c3f.svg";